import { useState } from 'react';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import Typography from '@/components/elements/Typography';
import TabButton from '@/components/elements/TabButton';
import Skeleton from '@/components/elements/Skeleton';

import Paper, { PaperProps } from '@/components/elements/Paper';
import { intervals, seriesesData } from './data';

const DynamicLineChart = dynamic(
  () => import(`@/components/elements/LineChart`),
  {
    ssr: false,
    loading: () => (
      <div className="px-4">
        <Skeleton className="h-[80px]" />
      </div>
    ),
  },
);

export type PortfolioChartProps = {
  positive?: boolean;
  disableAsset?: boolean;
  onlyLine?: boolean;
} & PaperProps;

/**
 * @component PortfolioChart
 */
function PortfolioChart({
  positive = true,
  className,
  disableAsset,
  ...rest
}: PortfolioChartProps) {
  const [activeInterval, setActiveInteval] = useState(0);

  const handleTimeButtonClick = (id: number) => {
    setActiveInteval(id);
  };

  const rootClasses = clsx(`w-full !p-0`, className);

  return (
    <Paper className={rootClasses} {...rest}>
      <div className="flex justify-between px-7 py-3 w-full mb-4">
        <div className="flex flex-col justify-center">
          <Typography
            variant="h2"
            className="text-gray-600 !leading-6 md:!leading-7"
          >
            ₿ 100.0
            <span className="text-gray-400">0</span>
          </Typography>
          <Typography variant="bodyBold" className="text-green-500">
            +0.38% ($100.89) Today
          </Typography>
        </div>
        {!disableAsset && (
          <div>
            <TabButton selected>BTC</TabButton>
          </div>
        )}
      </div>

      <div className="w-full mb-4">
        <DynamicLineChart
          data={seriesesData.get(intervals[activeInterval])}
          lineOptions={{ color: positive ? `#0E9F6E` : `#ff0000` }}
          className="w-full"
        />
      </div>

      <div className="flex w-full justify-around p-4">
        {intervals.map((label, index) => (
          <TabButton
            key={label}
            selected={activeInterval === index}
            onClick={() => handleTimeButtonClick(index)}
            size="small"
          >
            {label}
          </TabButton>
        ))}
      </div>
    </Paper>
  );
}

export default PortfolioChart;
